import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'antd';

import PreviewDates, { PeriodLabel } from './date-preview';
import './date-range-picker.less';
import messages from './messages';
import DateRangePickerModal from './date-range-picker-modal';

const DateRangePicker = ({ onChange, value, defaultValue, placeholder, allowCompare = true, layout = 'vertical' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleApply = (dateRange) => {
    setIsOpen(false);
    onChange(dateRange);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div className="date-range-picker">
      <DateRangePickerModal
        open={isOpen}
        onChange={handleApply}
        onCancel={handleCancel}
        defaultValue={defaultValue}
        allowCompare={allowCompare}
        value={value}
      />
      <Button block className="date-range-picker__button" onClick={() => setIsOpen(true)}>
        {value ? (
          <div className={layout}>
            <PeriodLabel dateRange={value} />
            <PreviewDates dateRange={value} />
          </div>
        ) : (
          placeholder || <FormattedMessage {...messages.placeholder} />
        )}
      </Button>
    </div>
  );
};

export default DateRangePicker;
